async function handleAuthError(response) {
  if (response.status !== 401) return false;
  const result = await response.clone().json().catch(() => null);
  if (result?.code === "token_not_valid") {
    window.dispatchEvent(new CustomEvent("session-expired"));
    const err = new Error("Sesión expirada");
    err.status = 401;
    err.payload = result;
    err.data = result;
    err.response = { status: 401, data: result };
    throw err;
  }
  return false;
}

function buildHttpError(response, errorPayload = {}) {
  const err = new Error(
    errorPayload?.error ||
    errorPayload?.detail ||
    errorPayload?.message ||
    `HTTP error! status: ${response.status}`,
  );
  err.status = response.status;
  err.payload = errorPayload;
  err.data = errorPayload;
  err.response = { status: response.status, data: errorPayload };
  return err;
}

export function isSessionExpiredError(error) {
  if (!error) return false;
  if (error?.payload?.code === "token_not_valid") return true;

  const status = Number(error?.status || error?.response?.status || 0);
  const message = String(error?.message || "").toLowerCase();
  return (
    status === 401 &&
    (message.includes("sesión expirada") || message.includes("sesion expirada"))
  );
}

export async function post(url, json) {
  const response = await fetch(url, {
    method: "post",
    body: JSON.stringify(json),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const restData=response.json();
  // if (!response.ok) {
  //   if (await handleAuthError(response)) return [];
  //   const errorPayload = await response.json().catch(() => ({}));
  //   throw new Error(errorPayload?.message || `HTTP error! status: ${response.status}`);
  // }
  return restData;
}

export async function postFormData(url, json) {
  const response = await fetch(url, {
    method: "post",
    body: json,
  });
  if (!response.ok) {
    await handleAuthError(response);
    const errorPayload = await response.json().catch(() => ({}));
    throw buildHttpError(response, errorPayload);
  }
  return response.json().catch(() => ({}));
}


export async function postHeader(url, json, auto) {
  const response = await fetch(url, {
    method: "post",
    body: JSON.stringify(json),
    headers: {
      "Content-Type": "application/json",
      Authorization: auto,
    },
  });
  if (!response.ok) {
    await handleAuthError(response);
    const errorPayload = await response.json().catch(() => ({}));
    throw buildHttpError(response, errorPayload);
  }
  return response.json().catch(() => ({}));
}

// HttpApi and crypto helpers removed since unused.
